import React, { useState } from 'react';
import { Sym } from './ui.jsx';

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => document.documentElement.dataset.theme || 'dark');
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    localStorage.setItem('theme', next);
    setTheme(next);
  };
  return (
    <button type="button" className="glass-pill round" onClick={toggle} aria-label={theme === 'dark' ? 'Light theme' : 'Dark theme'}>
      <Sym name={theme === 'dark' ? 'light_mode' : 'dark_mode'} size={18} />
    </button>
  );
};
